<ion-grid
  class="fullpage-grid"
  [ngClass]="classes"
>
  <ion-row>
    <ion-col>
      <ng-content select=".slate-top"></ng-content>
    </ion-col>
  </ion-row>
  <ion-row [ngClass]="hasCleanSlate() ? 'max-height' : ''">
    <ion-col #cleanSlateElem>
      <ng-content select=".clean-slate"></ng-content>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ng-content select=".slate-bottom"></ng-content>
    </ion-col>
  </ion-row>
</ion-grid>
